import { Dayjs } from "dayjs";

export type LeadsFiltersState = {
  category: string;
  stage: string;
  createdById: string;
  createdByName: string;
  reviewingAttorneyId: string;
  reviewingAttorneyName: string;
  createdFrom: Dayjs | null;
  createdTo: Dayjs | null;
  /** Encoded value, e.g. "lte:12", "gt:12", "none", or "". */
  terminationAge: string;
};

export const EMPTY_LEADS_FILTERS: LeadsFiltersState = {
  category: "",
  stage: "",
  createdById: "",
  createdByName: "",
  reviewingAttorneyId: "",
  reviewingAttorneyName: "",
  createdFrom: null,
  createdTo: null,
  terminationAge: "",
};

export type TerminationAgeOption = {
  value: string;
  label: string;
};

export const TERMINATION_AGE_OPTIONS: TerminationAgeOption[] = [
  { value: "lte:3", label: "Within 3 months" },
  { value: "lte:6", label: "Within 6 months" },
  { value: "lte:12", label: "Within 1 year" },
  { value: "lte:18", label: "Within 18 months" },
  { value: "lte:24", label: "Within 2 years" },
  { value: "lte:36", label: "Within 3 years" },
  { value: "gt:12", label: "Older than 1 year" },
  { value: "gt:24", label: "Older than 2 years" },
  { value: "none", label: "No termination date" },
];

export const FILTER_FIELD_LABELS: Record<
  keyof Omit<
    LeadsFiltersState,
    "createdByName" | "reviewingAttorneyName"
  >,
  string
> = {
  category: "Category",
  stage: "Stage",
  createdById: "Created by",
  reviewingAttorneyId: "Reviewing Attorney",
  createdFrom: "Created At from",
  createdTo: "Created At to",
  terminationAge: "Termination",
};

/** TableFilter.filterField values owned by the drawer (not search). */
export const DRAWER_FILTER_FIELDS = [
  "Category",
  "Status",
  "CreatedBy",
  "ReviewingAttorney",
  "CreatedFrom",
  "CreatedTo",
  "TerminationAge",
  // legacy field from Yes/No filter
  "TerminationWithinYear",
] as const;

export function terminationAgeLabel(value: string): string {
  return TERMINATION_AGE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
